import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';
import { apiClient } from '@cast/infrastructure-api';

const PERSISTENT_VOLUMES_SUMMARY_QUERY_KEY = 'persistent-volumes-summary';

const getPersistentVolumesSummaryQueryKey = (
  organizationId?: string,
  clusterId?: string
) => [PERSISTENT_VOLUMES_SUMMARY_QUERY_KEY, organizationId, clusterId] as const;

const getPersistentVolumesSummaryQueryOptions = ({
  organizationId,
  clusterId,
  enabled,
}: {
  organizationId: string;
  clusterId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getPersistentVolumesSummaryQueryKey(organizationId, clusterId),
    queryFn: async () => {
      const { data } = await apiClient.stop.getPersistentVolumesSummary({
        organizationId,
        clusterId: clusterId!,
      });
      return data;
    },
    enabled: makeIsEnabled(!!clusterId, enabled),
  });

export const usePersistentVolumesSummaryQuery = ({
  clusterId,
  enabled,
}: {
  clusterId?: string;
  enabled?: boolean;
} = {}) => {
  const organizationId = useCurrentOrganizationId();

  return useQuery(
    getPersistentVolumesSummaryQueryOptions({
      organizationId,
      clusterId,
      enabled,
    })
  );
};
